<template>
  <a
    class="collapse-toggle"
    :class="{'collapsed': collapsed}"
    data-toggle="collapse"
    :href="`#${target}`"
  >
    <icon icon="plus" class="icon" />
  </a>
</template>

<script>
export default {
  props: {
    target: { type: String, required: true },
    collapsed: { type: Boolean, default: true }
  }
};
</script>